import * as React from 'react';

var InlineNotice = function InlineNotice(_ref) {
    var children = _ref.children,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'warning' : _ref$type;
    return React.createElement(
        'div',
        {
            className: 'inline-alert inline-alert-visible inline-alert-' + type + ' ' + className
        },
        children
    );
};

InlineNotice.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    type: function type() {
        return (typeof bpfrpt_proptype_inlineNoticeType === 'function' ? bpfrpt_proptype_inlineNoticeType : PropTypes.shape(bpfrpt_proptype_inlineNoticeType)).apply(this, arguments);
    }
};
export default InlineNotice;
import { bpfrpt_proptype_inlineNoticeType } from '../../common/box-types';
import PropTypes from 'prop-types';